import { useGLTF } from '@react-three/drei';
import { useRef, useMemo } from 'react';
import { Mesh, CylinderGeometry, ConeGeometry, MeshStandardMaterial } from 'three';

export function Trees() {
  const treesRef = useRef < Mesh > (null);
  const { scene } = useGLTF("/models/tree.glb");

  const treePositions = useMemo(() => [
    [-40, 15], [-20, 15], [0, 15], [20, 15], [40, 15],
    [-40, -15], [-20, -15], [0, -15], [20, -15], [40, -15]
  ], []);

  // Create shared geometries and materials
  const [trunkGeo, trunkMat, topGeo, topMat] = useMemo(() => {
    const trunk = new CylinderGeometry(0.3, 0.5, 2, 6);
    const trunkMaterial = new MeshStandardMaterial({ color: '#4A3C2C' });
    const top = new ConeGeometry(2, 4, 6);
    const topMaterial = new MeshStandardMaterial({ color: '#2D5A27' });
    return [trunk, trunkMaterial, top, topMaterial];
  }, []);

  return (
    <group>
      {treePositions.map(([x, z], i) => (
        <primitive
          key={i}
          object={scene.clone()}
          position={[x, 0, z]}
          scale={[1, 1, 1]}
          castShadow
        />
      ))}
    </group>
  );
}